import { Link } from "react-router-dom";
import { FilledPrimaryBtn } from "./FilledBtn";
import { Form } from "react-bootstrap";
import TogglePasswordField from "./TogglePasswordField";
import { useState } from "react";
import DismissableAlert from "./DismissableAlert";
import AxiosClient from "../client/AxiosClient";
import { API_REGISTER_FACULTY } from "../ApiEndPoints";
import { SERVER_ERR_MSG } from "../DefaultMsg";
import InfoTooltip from "./InfoTooltip";

export default function FacultyRegistrationForm() {
  const [formValues, setFormValues] = useState({
    name: "",

    email: "",

    phone: "",

    teach_skill: "",
    teach_skill_explain: "",

    terms_accepted: false,
  });

  const [formErros, setFormErros] = useState({
    name: "",

    email: "",

    phone: "",

    teach_skill: "",
    teach_skill_explain: "",

    terms_accepted: "",
  });

  const [showLoader, setShowLoader] = useState(false);
  const [showAlert, setshowAlert] = useState({
    show: false,
    type: "",
    title: "",
    desc: "",
  });

  function setPasswordField(password) {
    setFormValues({ ...formValues, password: password });
  }

  function handleForm(event) {
    setShowLoader(true);
    event.preventDefault();

    setFormErros({
      name: "",

      email: "",

      phone: "",

      teach_skill: "",
      teach_skill_explain: "",

      terms_accepted: "",
    });

    const formData = new FormData();

    for (let key in formValues) {
      formData.append(key, formValues[key]);
    }

    AxiosClient.post(API_REGISTER_FACULTY, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        const { data: responseData } = response;

        if (responseData.success === true) {
          setFormErros({
            name: "",

            phone: "",

            teach_skill: "",
            teach_skill_explain: "",

            terms_accepted: false,
          });

          setshowAlert({
            show: true,
            type: "success",
            title: "",
            desc: responseData.message,
          });

          //   setTimeout(() => {
          //     navigateTo("/under-development");
          //   }, 1000);
        } else {
          setFormErros({
            name:
              responseData.errors.name != null ? responseData.errors.name : "",

            email:
              responseData.errors.email != null
                ? responseData.errors.email
                : "",

            phone:
              responseData.errors.phone != null
                ? responseData.errors.phone
                : "",

            teach_skill:
              responseData.errors.teach_skill != null
                ? responseData.errors.teach_skill
                : "",
            teach_skill_explain:
              responseData.errors.teach_skill_explain != null
                ? responseData.errors.teach_skill_explain
                : "",
          });

          setshowAlert({
            show: true,
            type: "danger",
            title: "",
            desc: responseData.message,
          });
        }
      })
      .catch((err) => {
        console.error(err);

        setshowAlert({
          show: true,
          type: "danger",
          title: "",
          desc: SERVER_ERR_MSG,
        });

        setShowLoader(false);
      })
      .finally(() => {
        setShowLoader(false);
      });
  }

  return (
    <Form onSubmit={handleForm}>
      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>
              Name
              <span className="required-mark text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={formValues.name}
              onChange={(event) =>
                setFormValues({ ...formValues, name: event.target.value })
              }
            />
            <span className="validation-err text-danger">{formErros.name}</span>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>
              Email <span className="required-mark text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={formValues.email}
              onChange={(event) =>
                setFormValues({ ...formValues, email: event.target.value })
              }
            />
            <span className="validation-err text-danger">
              {formErros.email}
            </span>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="mobile_no">
            <Form.Label>
              Mobile no. <span className="required-mark text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={formValues.phone}
              onChange={(event) =>
                setFormValues({ ...formValues, phone: event.target.value })
              }
            />
            <span className="validation-err text-danger">
              {formErros.phone}
            </span>
          </Form.Group>
        </div>

        <div className="col-md-12">
          <Form.Group className="mb-3" controlId="teach_skill">
            <Form.Label>What you can teach title </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={formValues.teach_skill}
              onChange={(event) =>
                setFormValues({
                  ...formValues,
                  teach_skill: event.target.value,
                })
              }
            />
            <span className="validation-err text-danger">
              {formErros.teach_skill}
            </span>
          </Form.Group>
        </div>

        <div className="col-md-12">
          <Form.Group className="mb-3" controlId="teach_skill_explain">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              style={{ height: "80px" }}
              onChange={(event) =>
                setFormValues({
                  ...formValues,
                  teach_skill_explain: event.target.value,
                })
              }
              maxLength={1024}
            />
            <span className="validation-err text-danger">
              {formErros.about}
            </span>
          </Form.Group>
        </div>

        <div className="col-md-12 d-flex">
          <Form.Check
            inline
            name="group1"
            type="checkbox"
            id={`inline-checkbox-1`}
            onChange={(event) =>
              setFormValues({
                ...formValues,
                terms_accepted: event.target.checked,
              })
            }
          />{" "}
          <label htmlFor="inline-checkbox-1">
            I have agreed to your <Link to="#">Jurisdiction</Link>,{" "}
            <Link to="#">Manual Feedback/ Ratings</Link> Policy
          </label>
          <div className="">
            <span className="validation-err text-danger">
              {formErros.terms_accepted}
            </span>
          </div>
        </div>

        {showAlert.show === true && (
          <DismissableAlert
            classes="mt-3"
            varient={showAlert.type}
            title={showAlert.title}
            desc={showAlert.desc}
          />
        )}

        <div className="col-md-12 text-center">
          <FilledPrimaryBtn
            classes="mt-4"
            label="Apply"
            type="submit"
            isLoading={showLoader}
          />
        </div>
      </div>
    </Form>
  );
}
